import { lazy } from "react";
export var LazySearchProductsRelatedSearchSection = /*#__PURE__*/ lazy(function() {
    return import(/* webpackChunkName: "styled-search-products-related-search-list" */ "./SearchProductsRelatedSearchSection").then(function(m) {
        return {
            default: m.SearchProductsRelatedSearchSection
        };
    });
});
